module.exports = __webpack_public_path__ + "static/media/video-placeholder.414ec787.jpg";